{
  "nav": {
    "pricing": "Preise",
    "contact": "Kontakt",
    "menu": "Menü",
    "login": "Anmelden",
    "features": "Funktionen",
    "brandHomeAria": "Done-it — Startseite",
    "market": {
      "belgium": "Belgien",
      "international": "Weltweit"
    }
  },
  "footer": {
    "tagline": "Done-it — Zeiterfassung einfach gemacht.",
    "terms": "AGB",
    "privacy": "Datenschutz",
    "contact": "Kontakt"
  },
  "help": "Brauchen Sie Hilfe?",
  "continue": "Weiter",
  "back": "Zurück",
  "change": "Ändern",
  "retry": "Erneut versuchen",
  "errors": {
    "unexpected": "Unerwarteter Fehler"
  },
  "step": {
    "of": "Schritt {{n}} von {{total}}"
  },
  "funnel": {
    "title": "Abonnement · Done-it"
  }
}
